import type { Transaction } from "@/types/api/user/home.type.data";

/**
 * The endpoint has been observed to return EITHER:
 *   - Transaction[]                                  (flat, current)
 *   - { data: Transaction[], total, currentPage, … } (paginated, legacy)
 *   - null / undefined
 * Normalize all of them to a plain array so `.map` is always safe.
 */
export const normalizeTransactions = (
  value: unknown
): Transaction[] => {
  if (Array.isArray(value)) return value as Transaction[];
  if (value && typeof value === "object") {
    const inner = (value as { data?: unknown }).data;
    if (Array.isArray(inner)) return inner as Transaction[];
  }
  return [];
};